import { ThemeContext } from '@/state/Theme';
import BlockLink from '../BlockLink';
import { type IconCardQuickLinksProps } from './IconCardQuickLinks.types';
import ButtonCircle from '../ButtonCircle';

const IconCardQuickLinks: React.FC<IconCardQuickLinksProps> = ({
  showTitle,
  title,
  linkExternal,
  linkInternal,
  linkText,
  content,
  items,
}) => (
  <ThemeContext.Consumer>
    {(theme) => (
      <div className="icon-card-quick-links">
        <div className="icon-card-quick-links__main" data-aos="fade-in">
          {showTitle ? (
            <h2 className="icon-card-quick-links__heading">{title}</h2>
          ) : null}

          {content && (
            <div
              className="icon-card-quick-links__content"
              dangerouslySetInnerHTML={{ __html: content }}
            />
          )}

          {linkText && (
            <BlockLink
              linkExternal={linkExternal}
              linkInternal={linkInternal}
              linkText={linkText}
              arrowFill={theme.brandColor}
              extraClasses="icon-card-quick-links__cta"
            />
          )}
        </div>
        <div className="icon-card-quick-links__links">
          {items && (
            <ul className="icon-card-quick-links__list">
              {items.map((item, index) => {
                const Element = item.link?.url ? 'a' : 'div';

                return (
                  <li
                    className="icon-card-quick-links__list-item"
                    data-aos="fade-in"
                    data-aos-delay={index * 100}
                    key={index}
                  >
                    <Element
                      className="icon-card-quick-link"
                      href={item.link.url}
                    >
                      <div className="icon-card-quick-link__content">
                        {item.iconPath && (
                          <img
                            className="icon-card-quick-link__icon"
                            src={item.iconPath}
                            alt=""
                            width="56"
                            height="56"
                          />
                        )}

                        {item.customIcon && (
                          <div
                            className="icon-card-quick-link__icon"
                            dangerouslySetInnerHTML={{
                              __html: item.customIcon,
                            }}
                          />
                        )}

                        <p className="icon-card-quick-link__heading h4">
                          {item.title}
                        </p>
                      </div>

                      {item.link.url && (
                        <ButtonCircle
                          arrowFill="currentColor"
                          arrowHeight={13}
                          arrowWidth={16}
                        />
                      )}
                    </Element>
                  </li>
                );
              })}
            </ul>
          )}
        </div>
      </div>
    )}
  </ThemeContext.Consumer>
);

export default IconCardQuickLinks;
